import React, { ReactNode } from 'react';
import PageMeta from '../../components/PageMeta';
import { useAuthContext } from '../../context/AuthContext';
import AdminHeader from './Admin/Header';
import AdminSidebar from './Admin/Sidebar';
import AdminShell from './AdminShell';

interface LayoutProps {
  children: ReactNode;
}

const AdminLayout: React.FC<LayoutProps> = ({ children }) => {
  const { store } = useAuthContext();

  return (
    <>
      <PageMeta title="店舗管理" noIndex />
      <AdminShell
        mobileHeaderTitle={store?.name ? `${store.name} 様` : ''}
        header={<AdminHeader />}
        sidebar={(closeSidebar) => <AdminSidebar onNavigate={closeSidebar} />}
      >
        {children}
      </AdminShell>
    </>
  );
};

export default AdminLayout;
